import React from 'react';
import Link from '../Link/Link';

const ExternalLink = props => <Link rel="noopener noreferrer" {...props} />;

ExternalLink.defaultProps = {
  target: '_blank',
};
export default ExternalLink;
